import atom, {useAtom} from "utils/atom";
import {User} from "auth/types";
import {isAtLeastModerator} from "utils/roles";

export const userAtom = atom<User | undefined | null>(null);

export const useAuthenticatedUser = () => {
  const user = useAtom(userAtom);
  if (!user) throw new Error("User not loaded yet");
  return user;
};

export const useAuthenticatedUserIsModeratorOrHigher = () => {
  const authUser = useAuthenticatedUser();
  return isAtLeastModerator(authUser.role);
};
